import React, { FC } from 'react';

import { AbgButton, AbgTypography, AmazonIcon, mergeSx } from '@abg/kit-base';

import * as styles from './amazon-login-button.styling';
import { AmazonLoginButtonProperties } from './amazon-login-button-types';

const AmazonLoginButton: FC<AmazonLoginButtonProperties> = ({
  btnCaption,
  buttonStyles,
  ...props
}) => {
  return (
    <AbgButton {...props} sx={mergeSx(styles.buttonStyles, buttonStyles)}>
      <AmazonIcon sx={styles.iconStyles} />
      <AbgTypography component="span">{btnCaption}</AbgTypography>
    </AbgButton>
  );
};

export default AmazonLoginButton;
